import { JSONObject } from '@services/events.service';

export class Event {
  constructor (public name: string,
               public attributes: JSONObject) {
  }
}
